import { useState } from 'react';

export const useFlashcardState = () => {
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [shuffled, setShuffled] = useState(false);
  const [cards, setCards] = useState([]);
  const [selectedCertification, setSelectedCertification] = useState(null);
  const [isTeamsContext, setIsTeamsContext] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  return {
    currentCardIndex,
    setCurrentCardIndex,
    shuffled,
    setShuffled,
    cards,
    setCards,
    selectedCertification,
    setSelectedCertification,
    isTeamsContext,
    setIsTeamsContext,
    isLoading,
    setIsLoading
  };
};
